import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Meeting} from "../../../shared/interface/meeting";
import {MeetingService} from "../../../shared/services/meeting.service";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import moment from "moment/moment";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {
  MEETING_TYPE_EXAM,
  MEETING_TYPE_IDD_TRAINING,
  MEETING_TYPE_NEW_AGENT_TRAINING,
  MEETING_TYPE_ENTRANCE_EXAM
} from "../../../shared/services/dict.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {Profile} from "../../../shared/interface/profile";
import {takeUntil} from "rxjs/operators";

export interface MeetingDetailsViewDialogData {
  meeting?: string;

}

@Component({
  selector: 'app-meeting-details-view-dialog',
  templateUrl: './meeting-details-view-dialog.component.html',
  styleUrls: ['./meeting-details-view-dialog.component.scss']
})
export class MeetingDetailsViewDialogComponent implements OnInit, OnDestroy {

  userPermissions: ReplaySubject<UserPermissions>;
  meetingObject: Meeting;
  meetingMinutes: number = null;
  meetingHours: number = null;
  val = false;
  modify = false;
  userProfile: Profile = null;
  meeting: ReplaySubject<Meeting> = new ReplaySubject<Meeting>(1);

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
   readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
   readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
   readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;

  constructor(
    private meetingService: MeetingService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MeetingDetailsViewDialogData
  ) {
    if (data.meeting)
    {
      this.meetingService.get(data.meeting).subscribe((meeting: Meeting) => {
        this.meeting.next(meeting);
        this.meetingObject = meeting;
        const startsAt = moment(meeting.startsAt);
        const endsAt = moment(meeting.endsAt);
        const minutes = endsAt.diff(startsAt, 'minutes');

        this.meetingHours = Math.floor(minutes / 60);
        this.meetingMinutes = minutes % 60;
        this.val = true;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Nie udało się pobrać danych egzaminu/szkolenia', error.status.toString(), {
          duration: 2000
        });
      });
    }
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.userProfile = profile;
      });
  }

  ngOnInit(): void {
  }
  downloadFile(uuid: string): void {
    this.meetingService.downloadFile(uuid);
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć to wydarzenie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.meetingService.delete(this.meetingObject.uuid)
          .subscribe( {
            next: () => {
            this.snack.open('Pomyślnie usunięto', '', {duration: 2000});
            this.dialogRef.close();
            },
            error: (error: HttpErrorResponse) => {
              if (error.error?.error?.text) {
                this.snack.open(error.error.error.text, '400', {duration: 4000});
              } else {
                this.snack.open('Nie można usunąć wydarzenia', error.status.toString(), {
                  duration: 2000,
                });
              }
            }
          });

      }
    });
  }

  edit(): void {
    this.modify = true;
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
